import { render } from "./merchantupgrade.vue?vue&type=template&id=2a6cac77&scoped=true"
import script from "./merchantupgrade.vue?vue&type=script&lang=js"
export * from "./merchantupgrade.vue?vue&type=script&lang=js"

import "./merchantupgrade.vue?vue&type=style&index=0&id=2a6cac77&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tap-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6cac77"]])

export default __exports__